import { createAction } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { call, all, put, takeLatest, select } from "redux-saga/effects";
import ApiService from "../../../services/ApiService";
import {
  setFormData,
  startFetching,
} from "../../reducers/ExpLogReducer";

export const fetchStaticData = createAction("experienceLog/fetchStaticData");
export const taskModelVersionChanged = createAction("experienceLog/taskModelVersionChanged");

function* filterTasksByVersion() {
  const isV6 = yield select(
    (state) => state.AppState.taskModelVersion === "v6"
  );
  const currentFormData = yield select((state) => state.ExpLog.formData);

  try {
    const tasks = yield call(ApiService.getTasks);
    const filteredTasks = (tasks?.data?.results || []).filter(
      (task) => task.version === (isV6 ? "v6" : "v5")
    );

    yield put(
      setFormData({
        ...currentFormData,
        tasks: filteredTasks || [],
      })
    );
  } catch (error) {
    console.log({ error });
  }
}

function* fetchData() {
  const isV6 = yield select(
    (state) => state.AppState.taskModelVersion === "v6"
  );
  yield put(startFetching(true));
  let expTypes,
    setting,
    supervisors,
    obsevations,
    methods,
    contacts,
    tasks,
    filteredTasks;
  try {
    expTypes = yield call(ApiService.getExperienceTypes);
    setting = yield call(ApiService.getSetting);
    supervisors = yield call(ApiService.getSupervisors);
    obsevations = yield call(ApiService.getClientObservation);
    methods = yield call(ApiService.getMethodSupervision);
    contacts = yield call(ApiService.getSupervisionContact);
    tasks = yield call(ApiService.getTasks);
    filteredTasks = (tasks?.data?.results || []).filter(
      (task) => task.version === (isV6 ? "v6" : "v5")
    );
  } catch (error) {
    console.log({ error });
  } finally {
    yield put(
      setFormData({
        expTypes: expTypes?.data?.results || [],
        setting: setting?.data?.results || [],
        supervisors: supervisors?.data?.results || [],
        obsevations: obsevations?.data?.results || [],
        methods: methods?.data?.results || [],
        contacts: contacts?.data?.results || [],
        tasks: filteredTasks || [],
      })
    );
    yield put(taskModelVersionChanged());
  }
}

export function* formDataSaga() {
  yield all([
    takeLatest(fetchStaticData, fetchData),
    takeLatest(taskModelVersionChanged, filterTasksByVersion)
  ]);
}